import { useNuxtApp, useRuntimeConfig } from "#imports";
import { useAutoPageviews } from "@barbapapazes/plausible-tracker/extensions/auto-pageviews";
import { defineNuxtPlugin } from "nuxt/app";
export default defineNuxtPlugin({
  name: "plausible:auto-pageviews",
  setup() {
    const options = useRuntimeConfig().public.plausible;
    const { $plausible } = useNuxtApp();
    if (options.enabled && options.autoPageviews) {
      useAutoPageviews($plausible).install();
    }
  }
});
